import {Core} from '@hybird/core/bridge/core'
import {WebError} from '@hybird/core/error'
import {deviceError} from '@hybird/device/deviceError'

const listen = []
window.callHandlerResult = (name, data) => {
  for (const i in listen) {
    listen[i].call(null, name, data)
  }
}

class FlutterBridge extends Core {
  _flutter = window.flutter_inappwebview

  constructor() {
    super()

    this._readyFn.push(() => {
      this.invoke('flutterReady', {}, {})
    })

    if (this._flutter?.callHandler) {
      this._isReady = true
      this._readyFn.forEach((fn) => fn())
      // } else if (this._flutter) {
      //   setTimeout(() => {
      //     this._flutter = window.flutter_inappwebview
      //     console.log('flutterInAppWebViewPlatformReady')
      //     this._readyFn.forEach((fn) => fn())
      //   }, 200);
    } else {
      window.addEventListener('flutterInAppWebViewPlatformReady', () => {
        this._flutter = window.flutter_inappwebview
        console.log('flutterInAppWebViewPlatformReady')
        this._readyFn.forEach((fn) => fn())
      })
    }

    this.on('removeEventListener', (params) => {
      this.off(params.name, {topic: params.topic})
    }, {isOne: true})
  }

  async invoke(name, params, {namespace = '', on = {}, parseResult = true}) {
    await super.invoke(name, params, {namespace})

    if (this._flutter.callHandler) {
      let result = await this._flutter.callHandler(this.parseName(name, namespace), params)

      if (this._flutter['x5']) {
        result = await new Promise((resolve) => {
          const fn = (x5Name, data) => {
            if (x5Name === name) {
              result = JSON.parse(data)

              resolve(result)
              const index = listen.indexOf(fn)
              if (index > -1) {
                // only splice array when item is found
                listen.splice(index, 1) // 2nd parameter means remove one item only
              }
            }
          }

          listen.push(fn)
        })
      }

      if (result) {
        if (result.code === 0) {
          for (const event in result.event) {
            if (typeof on[event] === 'function') {
              this.on(event, on[event], {params, topic: result.event[event]})
            }
          }
          const _method = result.method
          const method = {}

          for (const event in _method) {
            method[event] = (params = {}) => {
              return this.invoke(_method[event], params, {namespace})
            }
          }

          result.method = method

          if (parseResult) {
            return result.data
          }
        } else {
          throw WebError.code(deviceError.INVOKE_ERROR, {
            data: result, msg: result.errMsg
          })
        }
      }

      return result
    } else {
      throw WebError.code(deviceError.FLUTTER_INIT_ERROR)
    }
  }

  async on(name, event, {
    topic = name, params = {}, filter = () => true, namespace = '', isOne = false, isSend = false, off
  } = {}) {
    const eventName = this.parseName(name, namespace)
    await super.on(eventName, event, {
      topic, params, filter, namespace, isOne, isSend
    })

    if (isSend) {
      await this.invoke(eventName, params, {namespace})
    }

    this._addEventFn(name, event, {topic, filter, isOne})

    return {
      cancel: this.off.bind(this, name, {
        event, namespace, topic, isSend, off, params
      })
    }
  }

  flutterOn(event, params, {topic = event}) {
    const fns = this._getEventFn(event, {isOne: false})
    const results = []

    fns.events
            ?.filter((value) => value.topic === topic)
            .forEach((fn) => {
              try {
                results.push({
                  data: fn.event.call(fn, params), isOne: fn.isOne, success: true
                })
              } catch (e) {
                console.error(`处理${event}时出现异常, ${JSON.stringify(params)}`, e);

                results.push({
                  isOne: fn.isOne, success: false
                })
              }
            })

    return results.find((value) => value.success && value.isOne)
  }

  async off(id, {event, namespace, params = {}, topic, isSend = false, off}) {
    this._removeEventFn(id, {event, topic})

    if (isSend) {
      await this.invoke(off, params, {namespace})
    }
  }

  ready(event) {
    super.ready(event)

    return new Promise((resolve) => {
      const fn = () => {
        resolve()
        event()
      }

      //当flutter好后, 再次调用直接回调方法
      if (this._isReady) {
        fn()
      } else {
        this._readyFn.push(fn)
      }
    })
  }

  isSupport() {
    return !!this._flutter
  }
}

export {FlutterBridge}
